// src/services/flashcardService.js
import api from './api';

const flashcardService = {
  // Get all flashcards with filters
  getAllFlashcards: async (params = {}) => {
    const response = await api.get('/v1/flashcards', { params });
    return response.data;
  },

  // Get single flashcard
  getFlashcard: async (id) => {
    const response = await api.get(`/v1/flashcards/${id}`);
    return response.data;
  },

  // Create flashcard
  createFlashcard: async (flashcardData) => {
    const response = await api.post('/v1/flashcards', flashcardData);
    return response.data;
  },

  // Generate flashcards from note
  generateFromNote: async (noteId, count = 5) => {
    const response = await api.post('/v1/flashcards/generate', { noteId, count }, { timeout: 60000 }); // 60 second timeout for AI generation
    return response.data;
  },

  // Update flashcard
  updateFlashcard: async (id, flashcardData) => {
    const response = await api.put(`/v1/flashcards/${id}`, flashcardData);
    return response.data;
  },

  // Review flashcard (update mastery)
  reviewFlashcard: async (id, isCorrect) => {
    const response = await api.post(`/v1/flashcards/${id}/review`, { isCorrect });
    return response.data;
  },

  // Delete flashcard
  deleteFlashcard: async (id) => {
    const response = await api.delete(`/v1/flashcards/${id}`);
    return response.data;
  },

  // Get flashcard decks
  getDecks: async () => {
    const response = await api.get('/v1/flashcards/decks');
    return response.data;
  },

  // Create deck
  createDeck: async (deckData) => {
    const response = await api.post('/v1/flashcards/decks', deckData);
    return response.data;
  },

  // Get study session (cards due for review)
  getStudySession: async (params = {}) => {
    const response = await api.get('/v1/flashcards/study-session', { params });
    return response.data;
  },

  // Get flashcard stats
  getStats: async () => {
    const response = await api.get('/v1/flashcards/stats');
    return response.data;
  },

  // Toggle flashcard mastery
  toggleMastery: async (id, mastered) => {
    const response = await api.patch(`/v1/flashcards/${id}/mastery`, { mastered });
    return response.data;
  },

  // Generate exam questions from a note
  generateExamQuestions: async (noteId, count = 5, difficulty = 'medium') => {
    const response = await api.post('/v1/flashcards/generate-exam-questions', { noteId, count, difficulty }, { timeout: 60000 }); // 60 second timeout for AI generation
    return response.data;
  },

  // Export flashcards to PDF
  exportToPDF: async () => {
    const response = await api.get('/v1/flashcards/export-pdf', { responseType: 'blob' });
    return response;
  }
};

export default flashcardService;
